"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, CarouselContent, CarouselItem } from "@repo/design-system/components/ui/carousel";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import Autoplay from "embla-carousel-autoplay";
import { memo } from "react";
const SLIDE_COUNT = 8;
const slides = Array.from({
  length: SLIDE_COUNT
}, (_, index) => ({
  mobile: `images/header/subclients/sverige/jobboard/sverige_jobboard_mobile${index + 1}.webp`,
  desktop: `images/header/subclients/sverige/jobboard/sverige_jobboard_desktop${index + 1}.webp`
}));
function HeaderImageJobboardEonSverige() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      loop: true,
      watchDrag: false
    };
    t1 = [Autoplay({
      delay: 4000,
      stopOnInteraction: false
    })];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><Carousel opts={t0} plugins={t1}><CarouselContent>{slides.map(_temp)}</CarouselContent></Carousel></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp(item, index) {
  return <CarouselItem className="relative aspect-[3/2] h-full w-full md:aspect-[2000/650]" key={item.desktop}><CustomImage className="object-cover md:hidden" fill={true} priority={index === 0} sizes="100vw" src={item.mobile} /><CustomImage className="hidden object-cover md:block" fill={true} priority={index === 0} sizes="100vw" src={item.desktop} /></CarouselItem>;
}
export default memo(HeaderImageJobboardEonSverige);